export const getParentMenuUrl = () => {
  const splitPathnameUrl = location.pathname.split('/');
  const containWordDetail = splitPathnameUrl.includes('detail');
  const indexParentMenu = containWordDetail ? 3 : splitPathnameUrl.length > 4 ? 2 : 1;
  const getUrl = splitPathnameUrl[splitPathnameUrl.length - indexParentMenu];

  return getUrl;
};
